<template>
  <div class="box">
    <div ref="top">
      <headerTop v-if="baseInfo!=null" :baseInfo="baseInfo" :englishpc="englishpc" :isregister='isregister'></headerTop>
      <i-header :slides="slides" :banner="template.tmpImg"></i-header>
      <ul class="nav">
        <!--如果导航类型不是6 不是报名 -->
        <li v-if="template && template.navs.length>0 && nav.navType!=6"
            :key="i"
            @mouseover="mouseoverNav(i)"
            @mouseout="mouseoutNav(i)"
            @click="clickNav(nav,i)"
            :class="{active: activeNav===i? true: false}"

            v-for="(nav,i) in template.navs" class="nav1">
          <span v-if="nav.navType != 3" ref="navSpan"
                :style="{color: activeNav===i ? color: '#333'}">{{nav.navName}}</span>
          <span v-if="nav.navType == 3" ref="navSpan" :style="{color: activeNav===i ? color: '#333'}"><a target="_blank"
                                                                                                         class="out-link"
                                                                                                         :href="nav.navUrl">{{nav.navName}}</a></span>
          <ul class="nav2" v-if="nav.comps.length>1">
            <li
              :style="{color: item.activeId == (activeNav + '-' + activeNav2) ? color : '#333'}"
              :class="{active: item.activeId == (activeNav + '-' + activeNav2) ? true : false}"
              @click.stop="setNav2(i,j,nav)"
              :key="j"
              @mouseover="mouseoverNav1" @mouseout="mouseoutNav1"
              v-for="(item,j) in nav.comps">
              {{item.cpnTitle}}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="contain clear">
      <div ref="container" class="c-left left" style="min-height: 1px;overflow: hidden;">
        <rcom :activeNav="activeNav" :color="color" v-if="template" :currentNavCon="currentNavCon"></rcom>
      </div>
      <div ref="action" class="c-right left">
        <div class="contain-box">
          <ul class="zhuce-list" v-if="baseInfo!=null">
            <!--:class="{cursor: baseInfo.registerfl,cursor1: baseInfo.registerFl == 0}"-->
            <li @click="login()" class="cursor" v-if="baseInfo.registerFl ==1">
              <div class="zl">
                  <span>
                      <img src="./images/login1.png" alt=""/>
                  </span>

                <span style="color: #8fc31f;">{{ $t('message.tpl1.menu.register') }}</span>
              </div>
              <div class="zr">
                <img src="./images/arrow.png" alt=""/>
              </div>
            </li>
            <!--:class="{cursor: baseInfo.groupRegisterFl ==1,cursor1: baseInfo.groupRegisterFl ==0}"-->
            <li @click="teamReg" class="cursor" v-if="baseInfo.groupRegisterFl ==1">
              <div class="zl">
                  <span>
                    <img src="./images/login2.png" alt=""/>
                  </span>

                <span style="color: #f39800;">{{ $t('message.tpl1.menu.teamReg') }}</span>
              </div>
              <div class="zr">
                <img src="./images/arrow.png" alt=""/>
              </div>
            </li>
            <!--:class="{cursor: baseInfo.paperSubmitFl ==1,cursor1: baseInfo.paperSubmitFl ==0}"-->
            <li @click="reg1" class="cursor" v-if="baseInfo.paperSubmitFl ==1">
              <div class="zl">
                  <span>
                    <img src="./images/login3.png" alt=""/>
                  </span>
                <span style="color: #00a0e9;">{{ $t('message.tpl1.menu.paperRegister') }}</span>
              </div>
              <div class="zr">
                <img src="./images/arrow.png" alt=""/>
              </div>
            </li>
          </ul>


          <!--开幕时间-->
          <div class="kaimu" v-if="baseInfo!=null">
            <div class="title" v-if="baseInfo.cStartDt==''||baseInfo.cStartDt==null">
              <span>
                {{ $t("message.tpl3.menu.notic") }}
              </span>

            </div>

            <div  class="title" style="color: #333;" v-if="(isShowTime)&&baseInfo.cStartDt">
              <!--<i style="font-size: 25px;margin-right: 12px;" :style="{color: color}" class="iconfont icon-daojishi"></i>-->
              <!--{{ $t("message.tpl3.menu.daysDistance") }}-->
              <!--<span class="light" :style="{color: color}" style="font-size: 25px;" v-if="baseInfo">{{baseInfo.cStartDt | diffDays}}</span>-->
              <!--<span>{{ $t("message.tpl3.menu.day") }}</span>-->

                <span>{{ $t("message.tpl3.menu.conferenceS") }}</span>
                <span class="light" :style="{color: color}"
                      style="font-size: 25px;"
                      v-if="baseInfo">{{days}}</span>
                <span>{{ $t("message.tpl3.menu.day") }}</span>
                <span class="light" :style="{color: color}"
                      style="font-size: 25px;"
                      v-if="baseInfo">{{hours}}</span>
                <span>{{ $t("message.tpl3.menu.hours") }}</span>
                <span class="light" :style="{color: color}"
                      style="font-size: 25px;"
                      v-if="baseInfo">{{minutes}}</span>
                <span>{{ $t("message.tpl3.menu.minutes") }}</span>
                <span class="light" :style="{color: color}"
                      style="font-size: 25px;"
                      v-if="baseInfo">{{seconds}}</span>
                <span>{{ $t("message.tpl3.menu.seconds") }}</span>
            </div>

            <ul class="kaimu-time">
              <li v-if="baseInfo.cStartDt && baseInfo.cEndDt">
                <span class="label-time">{{ $t("message.tpl3.menu.mettingDate") }}</span> <span class="time">{{baseInfo.cStartDt}} <span
                style="margin-left: 5px;margin-right: 5px;"> {{ language === 'en' ? 'to' : '-' }} </span> {{baseInfo.cEndDt}}</span>
              </li>

              <li v-if="baseInfo.cfgApplyEnd && baseInfo.cfgApplyEnd.length>0">
                <span class="label-time">{{ $t("message.tpl3.menu.registerEndDate") }}</span> <span class="time">{{baseInfo.cfgApplyEnd}}</span>
              </li>
              <li v-if="baseInfo.cSpotRegisterStart && baseInfo.cSpotRegisterStart.length>0">
                <span class="label-time">{{ $t("message.tpl3.menu.reportDate") }}</span> <span
                class="time">{{baseInfo.cSpotRegisterStart}}</span>
              </li>
              <li v-if="baseInfo.cPaperSubmitEndDt && baseInfo.cPaperSubmitEndDt.length>0">
                <span class="label-time">{{ $t("message.tpl3.menu.paperEndDate") }}</span> <span class="time">{{baseInfo.cPaperSubmitEndDt}}</span>
              </li>
            </ul>
          </div>
          <!--联系我们-->
          <div v-if="navs.length>0">
            <!-- v-if="linkData.cpnContent!=null&&linkData.cpnContent!=''" -->
            <div class="link-us" >
              <div class="title" :style="{color: color}">
                <p style=" line-height: 80px;">{{linkTitle}}</p>
              </div>
              <div class="link-us-contain clear">
                <div class="v-html" v-html="linkData.cpnContent"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <cfooter></cfooter> -->
    <div style="text-align: center;margin-top: 70px;font-size: 0;">
      <img v-if="tmpBottomImg" :src="tmpBottomImg" alt="">
    </div>
    <login
      @close='login2'
      :color="color"
      :showBox="showBox"></login>
  </div>
</template>
<script>
  import bus from '@/bus'
  import rcom from './render-components.vue'
  import login from '@/components/login/login.vue'
  import loginlogic from '@/commen/loginlogic'
  import cfooter from '@/components/base/cfooter.vue'
  import {hasClass, addClass, removeClass, getScrollTop} from 'outils'
  import headerTop from '../../components/headerTop/headerTop'

  //轮播图
  import iHeader from  '../tplCommon/header_pic'

  let msg = {
    en: {
      register: 'Personal registration is not open',
      paperRegister: 'Online contributions are not open',
      teamReg: 'Team registration is not open ',
      logOutSuccess: 'successfully logged out'
    },
    ch: {
      register: '个人注册暂未开放',
      paperRegister: '在线投稿暂未开放',
      teamReg: '团队注册暂未开放',
      logOutSuccess: '退出成功!'
    },
  }
  export default {
    name: 'tpl3',
    data() {
      return {
        activeNav: 0,
        template: '',
        baseInfo: null,
        activeNav2: 0,
        showBox: false,
        tmpBottomImg: '',
        color: '#f39800',
        isLogin: false,
        language: 'cn',
        englishpc: 0,  //检查是否支持  英文网站
        user: {},
        navs: '',
        registerfl: false,
        ordertimer: null,  // 倒计时
        days: null, // 天
        hours: null, // 小时
        minutes: null, // 分钟
        seconds: null, // 秒
        isShowTime:true,
        isregister:'',

        //轮播图
        slides:[]
      }
    },
    props: {},
    methods: {
     // 转换时间格式 2017年08月15日  => 2017-08-15
      transDate(str) {
        if (str) {
          let reg = /[\u4e00-\u9fa5]/g;
          let targetDate = null
          if (reg.test(str)) {
            targetDate = new Date(str.replace(/[\u4e00-\u9fa5]/g, '-').slice(0, str.length - 1));
          } else {
            targetDate = new Date(str)
          }
          let startTime = new Date();
          return targetDate;
        } else {
          return 0
        }
      },
      // 倒计时
      leftTimer(enddate) {
        var leftTime = (new Date(enddate)) - (new Date()); //计算剩余的毫秒数
        var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
        var hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10); //计算剩余的小时
        var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
        var seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
        this.days = this.checkTime(days);
        this.hours = this.checkTime(hours);
        this.minutes = this.checkTime(minutes);
        this.seconds = this.checkTime(seconds);
        if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
          window.clearInterval(this.ordertimer);
          this.ordertimer = null;
        }
      },
      // 将0-9的数字前面加上0，例1变为01
      checkTime(i) {
        if(i <= 0){
          i='00'
        }else {
          if (i < 10) {
            i = "0" + i;

          }
        }
        return i;
      },


      mouseoverNav1(e) {
        e.target.style.color = this.color
      },
      mouseoutNav1(e) {
        if (hasClass(e.target, 'active')) {
          return
        }
        e.target.style.color = 'rgb(51, 51, 51)'
      },
      mouseoverNav(i) {
        this.$refs['navSpan'][i].style.color = this.color
        // e.target.style.color = this.color
      },
      mouseoutNav(i) {
        if (hasClass(this.$refs['navSpan'][i].parentNode, 'active')) {
          return;
        }
        this.$refs['navSpan'][i].style.color = '#333'
      },
      initFl() {
        if (this.navs.length > 0) {
          this.navs.map((item, i) => {
            if (item.navType == 6) {
              this.registerfl = true;
            }
          })
        }
      },
      checkLogin() {
        let token = localStorage.getItem('token');
        let uid = localStorage.getItem('uid');
        if (uid == null || !uid) {
//            跳转到登录页面
          if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
          }

          const origin = window.location.origin;
          const back = encodeURIComponent(location.href);
          location.href = origin + `/login?back=${back}&cid=${this.$route.params.cid}`;
//          this.showBox = true;
          return false;
        }
        return true;
      },
//      团队注册
      reg1() {
        if (this.baseInfo.paperSubmitFl == 0) {
          this.$Message.info(msg[this.language].paperRegister)
          return
        }
        if (this.checkLogin()) {
          let hostname = location.host;
          let cid = this.$route.params.cid;
            if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
          }
          let origin = window.location.origin;
          let url = window.location.href;
          // let path;
          let num = Math.random(); 
//           if(url.includes('www.medcircle.cn')) {
// path = `http://www.medcircle.cn/submission/#/submit_cn/paperView/0?cid=${cid}&tpl=tpl4home`
//           }else {
//             path = `http://www.medcircle.top/submission/#/submit_cn/paperView/0?cid=${cid}&tpl=tpl4home`
//           }
          let time = new Date().getTime();
          let path = `${origin}/submission/submit_cn/paperView/0?cid=${cid}&tpl=tpl4home`;
            // let path = `${origin}/submission/submit_cn/paperView/0?cid=${cid}&tpl=tpl4home`;
            window.open(path)
        }
      },
//      团队注册
      teamReg() {
        if (this.baseInfo.groupRegisterFl * 1 === 1) {
//              如果允许团队注册
          if (this.checkLogin()) {
//              如果登录成功
      if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
          }
            const origin = location.origin;
            const back = encodeURIComponent(location.href);
            location.href = origin + `/teamreg/${this.$route.params.cid}?back=${back}`;
            return;
          }
        } else {
          this.$Message.info(msg[this.language].teamReg);
        }
      },
      login2() {
        this.showBox = false;
        try {
          let user = localStorage.getItem('user') != null ? {} : localStorage.getItem('user');
          this.user = JSON.parse(localStorage.getItem('user'))
        } catch (err) {
          this.user = {};
        }

        let token = localStorage.getItem('token');
        if (token != null) {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }

      },
      login(path) {
        if (this.checkLogin()) {
          loginlogic.bind(this)(path);
        }
      },
      setNav2(i, j, nav) {
        this.activeNav = i; // 一级导航
        this.activeNav2 = j;//二级导航
        bus.$emit('closeSearch', false)
      },
      clickNav(nav, i) {
console.log(nav)
        this.activeNav2 = 0;
        this.activeNav = i;
        this.template.navs.map((nav, i) => {
          nav.shownav2 = false;
        });
        nav.shownav2 = true;
        // this.$refs['navSpan'].map((nav, i)=>{
        //   nav.parentNode.style.
        // })
        // this.$refs['navSpan'][i].parentNode
      },
      clickNav2(nav2, j) {
        this.template.navs.map((nav, i) => {
          nav.comps.map((item, j) => {
            item.active = false;
          })
        });
        nav2.active = true;
      },
      setPos() {
        let top = getScrollTop();
        let offsetTop = this.$refs['top'].offsetHeight;
        let action = this.$refs['action'];
        let containerHeight = this.$refs['container'].offsetHeight;
        let actionHeight = action.offsetHeight;
        if (containerHeight < actionHeight) return;
        if (!action) return;
        console.log(top - offsetTop)
        if (top > offsetTop) {
          let wWidth = window.innerWidth;
          let left = (wWidth - 1280) / 2 + 800;
          action.style.left = left + 'px';
          if (!hasClass(action, 'fixed')) {
            addClass(action, 'fixed')
          }
        } else {
          removeClass(action, 'fixed')
        }
      },
      /**@augments 处理获得模板之后的 逻辑 */
      dataFn(data) {
        console.log(data);
        let {englishpc} = data;
        if (englishpc == 0) {
          // 不支持英文
          localStorage.setItem('locale', 'ch');
          localStorage.setItem('englishpc', 0);
          // 切换i18n 语言
          this.$root._i18n.locale = 'ch';
          this.englishpc = 0
        } else {
          localStorage.setItem('englishpc', 1);
          this.englishpc = 1;
        }
        let liveInfos = data.navs.filter((nav, i) => nav.navType * 1 === 5);

        let liveInfo;
        if (liveInfos.length > 0) {
          liveInfo = liveInfos[0];
          let cpnData = {};
          cpnData['lives'] = data.data.lives;
          cpnData['icons'] = data.data.icons;
          liveInfo.comps = [{cpnData: cpnData, cpnCode: 'live'}];
          data.template.navs[data.template.navs.length] = liveInfo
        }

        data.template.navs.map((nav, i) => {
          nav.shownav2 = false;
        });
        data.template.navs.map((nav, i) => {
          nav.comps.map((com, j) => {
            com.activeId = `${i}-${j}`
          })
        })

        this.template = data.template
        //获取轮播图
        this.slides=data.slides;
        this.tmpBottomImg = data.template.tmpBottomImg;
        this.baseInfo = data.data.base_info;
        let defaultTime = this.transDate(this.baseInfo.cStartDt);
         if(new Date().getTime()<new Date(defaultTime).getTime()){
            this.isShowTime = true;
         }else{
           this.isShowTime = false;
         }
        localStorage.setItem('color', data.template.tmpColor == null ? '#f39800' : data.template.tmpColor);
        localStorage.setItem('cid', this.$route.params.cid);
//          设置css变量
        this.color = data.template.tmpColor == null ? '#f39800' : data.template.tmpColor;
        this.navs = data.navs;
        this.initFl();
        document.body.style.setProperty('--color', data.template.tmpColor);
        document.title = this.baseInfo.cTitle;
        this.isregister = data.isregister;
      },

      changeLang(value){
        this.language = value;
      }
    },
    computed: {
      //联系我们的数据
      linkData() {
        let linkdata = {}
        if (this.navs.length > 0) {
          this.navs.map((item, i) => {
            if (item.navType == 8) {
              if(item.comps.length >0){
                linkdata = item.comps[0]
              }
            }
          });
        }
        return linkdata;
      },
      linkTitle(){
        let title = null;
        if (this.navs.length > 0) {
          this.navs.map((item, i) => {
            if (item.navType == 8) {
              title = item.navName
            }
          });
        }
        return title;
      },
      currentNavCon() {
        // if (this.activeNav2 != "") {
        //   //          如果有二级导航
        //   return this.template.navs[this.activeNav].comps[this.activeNav2]
        // }

//          当前选中的导航的内容
if(this.template.navs[this.activeNav].comps.length>0){
  return this.template.navs[this.activeNav].comps[this.activeNav2]
}else{
  return [];
}



      },
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    components: {
      rcom, login, cfooter, headerTop,iHeader
    },
    filters: {
      diffDays(str) {
//            2017年08月15日  => 2017-08-15
        if (str) {
          let reg = /[\u4e00-\u9fa5]/g
          let targetDate = null
          if (reg.test(str)) {
            targetDate = new Date(str.replace(/[\u4e00-\u9fa5]/g, '-').slice(0, str.length - 1)).getTime();
          } else {
            targetDate = new Date(str).getTime()
          }
          let startTime = new Date().getTime();
          if (targetDate < startTime) {
            return 0;
          }
          return Math.floor(Math.abs((targetDate - startTime) / (1000 * 60 * 60 * 24)));
        } else {
          return 0
        }
      }
    },
    created() {
      localStorage.setItem('homePath', window.location.href);
      let uid = localStorage.getItem('uid');
      // 如果没有设置过语言
      let lang = localStorage.getItem('locale')
      if (lang === 'ch') {
        lang = 'cn'
      }
      // this.language = lang

      let params = {
        url: '/medapp/api/template/con/homepage',
        method: 'post', // default
        data: {
          cid: this.$route.params.cid,
          all_fl: 1,
          uid:uid
        },
        headers: {language: lang}
      };
      axios.request(params)
        .then(({data}) => {
          this.dataFn(data);


         let sTime = this.transDate(this.baseInfo.cStart)

          this.ordertimer = setInterval(() => {
            this.leftTimer(sTime)
          }, 1000);
        }).catch(() => {
        params.headers.language = 'cn';
        axios.request(params)
          .then(({data}) => {
            this.dataFn(data);
            let sTime = this.transDate(this.baseInfo.cStart);
            this.ordertimer = setInterval(() => {
              this.leftTimer(sTime)
            }, 1000);
          })
      })
    },
    mounted() {
      let token = localStorage.getItem('token');
      if (token) {
        this.isLogin = true;
        this.user = JSON.parse(localStorage.getItem('user'));
      }
      localStorage.setItem('homePath', location.href)
      this.language = localStorage.getItem('locale')
      // window.addEventListener('scroll', this.setPos)
      bus.$on('showSearch', flag => {
        console.log(flag)
      });
      this.englishpc = parseInt(localStorage.getItem('englishpc'));

    },
    beforeDestroy() {
      // window.removeEventListener('scroll', this.setPos)
    }



  }
</script>
<style lang="scss" scoped>
  .box {
    background-color: #F7F7F7;
    header {
      height: 40px;
      font-size: 12px;
      line-height: 40px;
      text-align: right;
    }
  }

  .contain {
    width: 1280px;
    margin: 0 auto;
    & > div {
    }
    .c-left {
      width: 808px;
    }
    .c-right {
      width: 472px;
    }
    .contain-box {
      margin-left: 8px;
    }
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .clear:after {
    content: '';
    display: block;
    clear: both;
  }

  .kaimu {
    margin-top: 8px;
    margin-bottom: 8px;
    background-color: #ffffff;
    overflow: hidden;
  }

  .title {
    border-bottom: 1px solid #eee;
    font-size: 18px;
    color: var(--color);
    height: 80px;


    span{
      margin-top: 21px;
      display: inline-block;
    }
    span.light {
      height: 37px;
      width: 50px;
      text-align: center;
      background: url("./images/timebg.png") no-repeat;
      color: var(--color);
    }
    /*line-height: 80px;*/
    padding-left: 22px;
  }

  .kaimu-time {
    max-height: 180px;
    padding: 11px 22px;
    line-height: 40px;
    font-size: 14px;
    .label-time {
      width: 170px;
      display: inline-block;
      color: #666666;
      .time {
        color: #333333;
      }
    }
  }

  .link-us {
    background-color: #ffffff;
  }

  .link-us-item {
    padding: 11px 22px;
    color: #333333;
    font-size: 12px;
  }

  .link-us-item li {
    margin-bottom: 17px;
  }

  .link-us-contain {
    width: 100%;
    padding: 10px 22px;
    max-height: 200px;
    overflow-y: auto;
    .link-us-item {
      width: 270px;
    }
    .ewm-box {
      text-align: center;
      margin-top: 11px;
    }
  }

  .zhuce-list {
    li {
      background: #fff;
      height: 50px;
      margin-bottom: 5px;
      padding: 0 10px;
      position: relative;
      .zl {
        height: 50px;
        display: table;
        img {
          display: table-cell;
          vertical-align: middle;
        }
        span {
          display: table-cell;
          font-size: 18px;
          vertical-align: middle;
          &:nth-child(2) {
            /*margin-left: 20px;*/
            padding-left: 16px;
          }
        }
      }
      .zr {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -20px;
      }

    }
  }

  .nav {
    width: 1280px;
    margin: 0 auto 10px;
    /*box-shadow:  0 4px 2px 0 rgba(0,0,0,0.5);*/
    border-bottom: 2px solid #e4e4e4;
    background-color: #ffffff;
    :after {
      content: '';
      clear: both;
    }
    height: 51px;
    /*display: table;*/
    & > li {
      float: left;
      width: 140px;
      /*display: table-cell;*/
      /*line-height: 60px;*/
      text-align: center;
      padding: 13px 0;
      position: relative;
      color: #333333;
      cursor: pointer;
      font-size: 14px;
      &.active {
        color: #00a0e9;
        &.nav1 {
          font-size: 16px;
        }
      }
      &.active:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #00a0e9;
        bottom: 0;
      }
    }
  }

  .nav1 {
    position: relative;
    color: #333333;
    font-size: 14px;
    &.active {
      /*font-size: 16px;*/
    }
    font-size: 14px;
    & > span {
      display: block;
      width: 100%;
      border-right: 1px solid #dbdbdb;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &:last-child > span {
      border: 0;
    }
    &:hover .nav2 {
      display: block;
    }
  }

  .nav2 {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #dcecff;
    line-height: 38px;
    color: #5898ce;
    display: none;
    z-index: 30;
    li {
      border-bottom: 1px solid #ffffff;
      font-size: 14px;
    }
  }

  .nav2 li:hover {
    background-color: #eeeeee;
  }

  .dk {
    display: inline-block;
    width: 34px;
    height: 34px;
    background: url("./images/dk.png") no-repeat center center/100%;
    vertical-align: middle;
    line-height: 34px;
    text-align: center;
  }

  .frends-link {
    width: 1280px;
    margin: 10px auto 10px;
    li {
      background-color: #ffffff;
      height: 80px;
      float: left;
      width: 248px;
      margin-right: 10px;
    }
    li:last-child {
      margin-right: 0;
    }
  }

  .login-btn {
    cursor: pointer;
  }

  .out-link {
    color: #333;
    display: block;
    width: 100%;
    height: 100%;
  }

  .cursor {
    cursor: pointer;
  }

  .cursor1 {
    background-color: #cccccc !important;
    border-right: 1px solid #ffffff
  }

  .fixed {
    position: fixed;
    top: 0;
  }

  .language {
    cursor: pointer;
    &.active {
      color: #114c9a;
    }
  }
</style>



// WEBPACK FOOTER //
// tpl4.vue?613134fa